import { useTabsState } from "@/contexts/tabs-context";
import { ProjectContainer } from "./project-container";

/**
 * ProjectsHost renders all open project tabs simultaneously.
 *
 * This is the core of the "keep-alive" tab system. Instead of mounting/unmounting
 * projects as users switch tabs (which loses all React state), we render ALL
 * open projects at once and control visibility with CSS.
 *
 * Benefits:
 * - Tree expansion state is preserved when switching tabs
 * - Sidebar widths are preserved
 * - Scroll positions are preserved
 * - Form input values are preserved
 * - Any other component-level state is preserved
 *
 * This is the same pattern used by Chrome tabs and VS Code.
 */
export function ProjectsHost() {
  const { tabs, activeTabId } = useTabsState();
  const projectTabs = tabs.filter((tab) => tab.kind === "project");

  if (projectTabs.length === 0) {
    return null;
  }

  return (
    <>
      {projectTabs.map((tab) => (
        <ProjectContainer
          key={tab.tabId}
          tabId={tab.tabId}
          projectId={tab.resourceId}
          isActive={tab.tabId === activeTabId}
          currentPath={tab.currentPath}
          searchParams={tab.searchParams}
          memory={tab.memory}
        />
      ))}
    </>
  );
}
